import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const Styles = StyleSheet.create({
  urgentImage: {
    width: 60,
    height: 100,
    alignSelf: 'center',
  },
  urgentBanner: {
    backgroundColor: Colors.gray.touch,
    borderRadius: grid(1),
  },
});
